import { FC, PropsWithChildren, useMemo, useState } from "react";

import { FormInstance } from "antd";
import { useForm } from "antd/es/form/Form";

import { ActivitiesSectionForm } from "../../../../../AP/Steps/StepFour/contexts/StepFourForm";
import { StepFourFormContext } from "./StepFourFormContext";

export const StepFourFormProvider: FC<PropsWithChildren> = ({ children }) => {
    const [ validitySectionForm ] = useForm<{ validityDate: any }>();

    const [ activitiesSectionForm ] = useForm<ActivitiesSectionForm>();

    const [ activitiesFormValues, setActivitiesFormValues ] = useState<ActivitiesSectionForm>();

    const [ methodSelectedFromStepThree, setMethodSelectedFromStepThree ] = useState<any>();

    const [ errorCreditCardMessage, setErrorCreditCardMessage ] = useState<string>('');

    const [stepFourForm, setStepFourForm] = useState<FormInstance<any>>();

    const values = useMemo(() => ({
        validitySectionForm,
        methodSelectedFromStepThree,
        setMethodSelectedFromStepThree,
        errorCreditCardMessage,
        setErrorCreditCardMessage,
        activitiesSectionForm,
        activitiesFormValues,
        setActivitiesFormValues,
        stepFourForm,
        setStepFourForm
    }), [
        validitySectionForm,
        methodSelectedFromStepThree,
        setMethodSelectedFromStepThree,
        errorCreditCardMessage,
        setErrorCreditCardMessage,
        activitiesSectionForm,
        activitiesFormValues,
        setActivitiesFormValues,
        stepFourForm,
        setStepFourForm
    ]);

    return (
        <StepFourFormContext.Provider value={ values }>              
            { children }
        </StepFourFormContext.Provider>
    )
}